import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { postLogin } from "../../api/Post";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children, userData }) => {
  const [user, setUser] = useState(userData); // useLocalStorage("nbk-token", userData);

  useEffect(() => {
    // console.log("[Auth Provider] User effect :", userData);
    setUser(userData);
  }, [userData]);

  const navigate = useNavigate();

  const login = async (data) => {
    const res = await postLogin(data);
    if (!res.error) setUser(Cookies.get("nbk-token"));
    // console.log("Will set user :", Cookies.get("nbk-token"));
    return res;
  };

  const logout = useCallback(() => {
    // console.log("LOGOUT lol");
    Cookies.remove("nbk-token");
    navigate("/", { replace: true });
  }, [navigate]);

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
    }),
    [logout, user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
